var _circle, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9897,
    cy: 14.6925,
    r: 14.439,
    fill: "url(#paint0_linear_1775_3705)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9162 25.8029C8.51217 25.8029 3.30249 20.6894 3.30249 14.4037C3.30249 8.11769 8.51217 3.00415 14.9162 3.00415C21.3202 3.00415 26.5302 8.11769 26.5302 14.4037C26.5302 20.6894 21.3202 25.8029 14.9162 25.8029Z",
    fill: "url(#paint1_linear_1775_3705)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7424 18.7857C18.7937 19.5147 18.0581 20.0414 17.3845 19.7581L15.2722 18.8694L13.1518 19.7386C12.4756 20.0157 11.7449 19.4823 11.8028 18.7539L11.9871 16.4331L10.497 14.6419C10.0327 14.0838 10.3151 13.2322 11.0209 13.062L13.264 12.5212L14.4729 10.5599C14.8579 9.93533 15.7673 9.93948 16.1465 10.5675L17.3378 12.5402L19.576 13.1016C20.2802 13.2782 20.5548 14.1323 20.0854 14.6862L18.5791 16.4635L18.7424 18.7857Z",
    fill: "#FFEFB9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1775_3705",
    x1: 11.9234,
    y1: -3.47692,
    x2: -2.70612,
    y2: 20.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1775_3705",
    x1: 13.7945,
    y1: -1.20554,
    x2: 0.220897,
    y2: 16.9466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99912"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/gold-icon.a6a322cdf693b1cd83e0b97a0b5528cc.svg";
export { ForwardRef as ReactComponent };